import { SelectHTMLAttributes, useContext, useState } from 'react';
import * as S from './styles';
import { RiArrowDownSLine } from 'react-icons/ri';
import Skeleton from 'react-loading-skeleton';
import * as CXT from 'context/globalContext';
import { size } from 'lodash';

type SelectOption = {
  value: string;
  label: string;
};

type SelectProps = {
  title?: string;
  options: SelectOption[];
  height?: string;
  width?: string;
  error?: boolean;
  errorMessage?: string;
  selectTheme?: 'default' | 'valid' | 'invalid';
  valid?: boolean;
  searchable?: boolean;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
} & SelectHTMLAttributes<HTMLSelectElement>;

const Select = ({
  title = 'Digite a Label',
  options,
  width,
  height,
  errorMessage = 'Campo obrigatório',
  error = false,
  selectTheme,
  valid = false,
  searchable = false,
  value,
  onChange,
  ...rest
}: SelectProps) => {
  const globalContext = useContext(CXT.Context);
  const [filter, setFilter] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <S.Wrapper>
      {globalContext.isLoading ? (
        <>
          <S.SkelBox>
            <Skeleton />
          </S.SkelBox>
          <Skeleton />
        </>
      ) : (
        <>
          <S.Label>{!!title && title}</S.Label>

          <S.SelectContainer>
            <S.SelectWrapper onClick={toggleDropdown} error={error}>
              <span>
                {value
                  ? options.find((opt) => opt.value === value)?.label
                  : 'Selecione...'}
              </span>
              <RiArrowDownSLine size={26} color="#2a99fb" />
            </S.SelectWrapper>

            {isOpen && (
              <S.Dropdown>
                {searchable && (
                  <S.SearchInput
                    type="text"
                    placeholder="Pesquisar..."
                    value={filter}
                    onChange={handleInputChange}
                  />
                )}

                <S.OptionsList>
                  {filteredOptions.map((option) => (
                    <S.Option
                      key={option.value}
                      onClick={() => {
                        onChange?.({
                          target: { value: option.value },
                        } as React.ChangeEvent<HTMLSelectElement>);
                        setIsOpen(false);
                        setFilter('');
                      }}
                      selected={option.value === value}
                    >
                      {option.label}
                    </S.Option>
                  ))}
                  {size(filteredOptions) == 0 && (
                    <S.Option>Não encontrado</S.Option>
                  )}
                </S.OptionsList>
              </S.Dropdown>
            )}
          </S.SelectContainer>

          {error && <S.MsgError>{errorMessage}</S.MsgError>}
        </>
      )}
    </S.Wrapper>
  );
};

export default Select;
